// ReportDepthSection.jsx
// Shows all 10 report chapters as a card grid so users understand
// this is a deep, multi-layer system — not a 4-bullet horoscope.
import React from "react";

export default function ReportDepthSection({ heading, subheading, chapters = [] }) {
  return (
    <div className="sx-container">
      <div className="sx-depth-wrapper">
        {heading && <h3 className="sx-pipeline-heading">{heading}</h3>}
        {subheading && <p className="sx-pipeline-sub">{subheading}</p>}

        <div className="sx-depth-grid">
          {chapters.map((ch, i) => (
            <div key={i} className="sx-depth-card">
              <div className="sx-depth-card-left">
                <div className="sx-depth-card-num">{String(i + 1).padStart(2, "0")}</div>
                <div className="sx-depth-card-icon">{ch.icon}</div>
              </div>
              <div className="sx-depth-card-body">
                <div className="sx-depth-card-title">{ch.title}</div>
                <div className="sx-depth-card-desc">{ch.desc}</div>
                {Array.isArray(ch.tags) && ch.tags.length > 0 && (
                  <div className="sx-depth-card-tags">
                    {ch.tags.map((tag, j) => (
                      <span key={j} className="sx-depth-tag">{tag}</span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
